// ===== Busca de produtos que tolera o jeito de escrever =====
//
// Reteste do Kaio (25/09): "a busca por itens deve ser melhorada, os itens devem
// aparecer como sugestão mesmo sem estar escrito exatamente igual". A busca era
// `includes` do texto digitado: "4120C-10/50" não achava "PDL4120C-10/50/67/BR"
// se a pessoa escrevesse "4120c 10 50", "4120C 10/50" ou "pdl 4120c".
//
// Regra: compara sem acento, sem caixa e SEM separadores (espaço, traço, barra,
// ponto); cada palavra digitada tem de aparecer no código, no nome ou na
// descrição técnica, em qualquer ordem. Ordena pelo que casa melhor.
//
// Puro, sem React: usado pela proposta e pela tela de produtos.

export const normalizar = (s) => String(s ?? '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().replace(/[^a-z0-9]/g, '');

const palavras = (termo) => String(termo ?? '')
  .normalize('NFD').replace(/[̀-ͯ]/g, '')
  .toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

// O texto normalizado de cada produto, calculado UMA vez. Reteste do Kaio
// (25/09): "a busca por produtos está um pouco lenta". Medido: ~100 ms por
// tecla com 15,5 mil produtos, quase tudo em normalizar o catálogo inteiro de
// novo a cada letra. WeakMap pelo objeto do produto: produto editado vira objeto
// novo (e texto novo), e o que sai do catálogo não fica preso na memória.
const JA_NORMALIZADO = new WeakMap();
function normalizado(produto) {
  let n = JA_NORMALIZADO.get(produto);
  if (!n) {
    n = {
      codigo: normalizar(produto.codigo || produto.sku),
      nome: normalizar(produto.nome),
      texto: normalizar(`${produto.descricaoEstendida || ''} ${produto.descricao || ''}`),
    };
    JA_NORMALIZADO.set(produto, n);
  }
  return n;
}

/** Pontua um produto para o termo; 0 = não casa. Maior = melhor. */
export function pontuar(produto, termo) {
  const alvoTermo = normalizar(termo);
  if (!alvoTermo) return 0;
  const { codigo, nome, texto } = normalizado(produto);
  if (codigo === alvoTermo) return 1000;
  if (codigo.startsWith(alvoTermo) || codigo.startsWith('pdl' + alvoTermo)) return 800;
  if (codigo.includes(alvoTermo)) return 600;
  if (nome.includes(alvoTermo)) return 400;
  const ps = palavras(termo);
  if (ps.length && ps.every((p) => codigo.includes(p) || nome.includes(p) || texto.includes(p))) {
    // Mais palavras no código = mais específico.
    return 200 + ps.filter((p) => codigo.includes(p)).length;
  }
  return 0;
}

/** Os produtos que casam com o termo, do mais para o menos parecido. */
export function buscarProdutos(produtos, termo, { limite = 60 } = {}) {
  if (!normalizar(termo)) return produtos.slice(0, limite);
  const achados = [];
  for (const p of produtos) {
    const pontos = pontuar(p, termo);
    if (pontos) achados.push([pontos, p]);
  }
  achados.sort((a, b) => b[0] - a[0] || String(a[1].codigo).length - String(b[1].codigo).length);
  return achados.slice(0, limite).map(([, p]) => p);
}
